<template>
  <div>
    <ion-card>
      <ion-list :inset="true">
        <ion-item button @click="goProfile">
          <ion-icon slot="start" color="grey" :icon="personCircle" size="small"></ion-icon>
          <ion-label>{{ t('profile.personalData') }}</ion-label>
        </ion-item>
        <ion-item button @click="goAccount">
          <ion-icon slot="start" color="grey" :icon="personCircle" size="small"></ion-icon>
          <ion-label>{{ t('profile.myAccount') }}</ion-label>
        </ion-item>
        <ion-item button @click="goDocument">
          <ion-icon color="grey" slot="start" :icon="folder" size="small"></ion-icon>
          <ion-label>{{ t('profile.documents') }}</ion-label>
        </ion-item>
        <ion-item button @click="goSetting">
          <ion-icon color="grey" slot="start" :icon="settings" size="small"></ion-icon>
          <ion-label>{{ t('profile.settings') }}</ion-label>
        </ion-item>
      </ion-list>
    </ion-card>

    <ion-button
      id="open-action-sheet"
      fill="solid"
      expand="block"
      size="default"
      color="primary"
      class="text-lg text-weight-bold"
    >
      <ion-icon slot="start" :icon="logOutOutline" inner="true"></ion-icon>
      {{ t('global.logout') }}
    </ion-button>

    <ion-action-sheet
      :header="t('global.logout')"
      :sub-header="t('actions.logoutText')"
      trigger="open-action-sheet"
      :buttons="actionSheetButtons"
      @didDismiss="checkResult($event)"
    ></ion-action-sheet>
  </div>
</template>
<script setup lang="ts">
  import { folder, personCircle, settings } from 'ionicons/icons';
  import {
    IonCard,
    IonList,
    IonItem,
    IonIcon,
    IonLabel,
    IonButton,
    IonActionSheet,
  } from '@ionic/vue';
  import { logOutOutline } from 'ionicons/icons';
  import router from '@/router';
  import { useI18n } from 'vue-i18n';
  import { ref } from 'vue';
  import { useAuthStore } from '@/stores/auth-store';

  const { t } = useI18n();
  const { authLogout } = useAuthStore();

  const goProfile = () => {
    router.push({ name: 'profile.my' });
  };

  const goAccount = () => {
    router.push({ name: 'profile.account' });
  };

  const goDocument = () => {
    router.push({ name: 'profile.documents' });
  };

  const goSetting = () => {
    router.push({ name: 'profile.settings' });
  };

  const actionSheetButtons = ref([
    {
      text: t('actions.yesLogout'),
      role: 'destructive',
      data: {
        action: 'logout',
      },
    },
    {
      text: 'No',
      role: 'cancel',
      data: {
        action: 'cancel',
      },
    },
  ]);

  const checkResult = (ev: CustomEvent) => {
    if (ev && ev.detail.data && ev.detail.data.action === 'logout') {
      authLogout();
    }
  };
</script>
<style scoped lang="scss">
  ion-card {
    padding: 0;
    margin-top: 0;
    box-shadow: none;
  }

  ion-list {
    margin-inline-start: 0 !important;
    margin-inline-end: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    background: white;
    border-radius: 50px;
  }

  ion-item {
    --background: white;
    border: none;
    padding: 5px;
    --color: var(--ion-color-placeholder);
    font: {
      family: 'Roboto', sans-serif;
      weight: 600;
      size: 15px;
    }
  }

  .menu-wrapper {
    background: white;
  }
</style>
